import React from "react"

import CodeBlock from "~components/CodeBlock"

const PreWrapper = ({ children, ...rest }) => {
  const wrap = children?.[0]?.props?.className?.startsWith("language-")

  if (wrap) {
    const language = children?.[0]?.props?.className?.split("language-")[1]
    const code = children[0].props.children[0]
    return <CodeBlock code={code} language={language} />
  }
  return <pre {...rest}>{children}</pre>
}

export default PreWrapper
